import {
	SET_ERROR,
	CORE_AUTH_VERIFY_SUCCESS,
	CORE_AUTH_VERIFY_FAILURE,

	CORE_GET_ALL_TRANSFERS_REQUEST,
	CORE_GET_ALL_TRANSFERS_SUCCESS,
	CORE_GET_ALL_TRANSFERS_FAILURE,

	CORE_GET_TRANSFER_BY_ID_REQUEST,
	CORE_GET_TRANSFER_BY_ID_SUCCESS,
	CORE_GET_TRANSFER_BY_ID_FAILURE,

	CORE_CREATE_TRANSFER_REQUEST,
	CORE_CREATE_TRANSFER_SUCCESS,
	CORE_CREATE_TRANSFER_FAILURE,

	CORE_TRANSFER_ITEM_REQUEST,
	CORE_TRANSFER_ITEM_SUCCESS,
	CORE_TRANSFER_ITEM_FAILURE,

	CORE_GET_SETTINGS_REQUEST,
	CORE_GET_SETTINGS_SUCCESS,
	CORE_GET_SETTINGS_FAILURE,

	CORE_UPSERT_SETTINGS_REQUEST,
	CORE_UPSERT_SETTINGS_SUCCESS,
	CORE_UPSERT_SETTINGS_FAILURE,

	CORE_GET_RM_TAG_REQUEST,
	CORE_GET_RM_TAG_SUCCESS,
	CORE_GET_RM_TAG_FAILURE,

	CORE_GET_PD_TAG_REQUEST,
	CORE_GET_PD_TAG_SUCCESS,
	CORE_GET_PD_TAG_FAILURE,

	CORE_GET_DELIVERY_TAG_REQUEST,
	CORE_GET_DELIVERY_TAG_SUCCESS,
	CORE_GET_DELIVERY_TAG_FAILURE,

	CORE_GET_PO_RECEIPT_REQUEST,
	CORE_GET_PO_RECEIPT_SUCCESS,
	CORE_GET_PO_RECEIPT_FAILURE,

	CORE_GET_LIST_SO_REQUEST,
	CORE_GET_LIST_SO_SUCCESS,
	CORE_GET_LIST_SO_FAILURE,

	CORE_GET_SO_INFO_REQUEST,
	CORE_GET_SO_INFO_SUCCESS,
	CORE_GET_SO_INFO_FAILURE,

	CORE_GET_SO_PICK_REQUEST,
	CORE_GET_SO_PICK_SUCCESS,
	CORE_GET_SO_PICK_FAILURE,

	CORE_GET_ALL_AX_RAW_MAT_REQUEST,
	CORE_GET_ALL_AX_RAW_MAT_SUCCESS,
	CORE_GET_ALL_AX_RAW_MAT_FAILURE,

	CORE_GET_ALL_RAW_MATERIAL_REQUEST,
	CORE_GET_ALL_RAW_MATERIAL_SUCCESS,
	CORE_GET_ALL_RAW_MATERIAL_FAILURE,

	CORE_GET_RAW_MATERIAL_BY_ID_REQUEST,
	CORE_GET_RAW_MATERIAL_BY_ID_SUCCESS,
	CORE_GET_RAW_MATERIAL_BY_ID_FAILURE,

	CORE_CREATE_RAW_MATERIAL_REQUEST,
	CORE_CREATE_RAW_MATERIAL_SUCCESS,
	CORE_CREATE_RAW_MATERIAL_FAILURE,

	CORE_UPDATE_RAW_MATERIAL_REQUEST,
	CORE_UPDATE_RAW_MATERIAL_SUCCESS,
	CORE_UPDATE_RAW_MATERIAL_FAILURE,

	CORE_DELETE_RAW_MATERIAL_REQUEST,
	CORE_DELETE_RAW_MATERIAL_SUCCESS,
	CORE_DELETE_RAW_MATERIAL_FAILURE,

	CORE_APPROVE_RAW_MATERIAL_REQUEST,
	CORE_APPROVE_RAW_MATERIAL_SUCCESS,
	CORE_APPROVE_RAW_MATERIAL_FAILURE,

	CORE_SEND_RAW_MATERIAL_REQUEST,
	CORE_SEND_RAW_MATERIAL_SUCCESS,
	CORE_SEND_RAW_MATERIAL_FAILURE,

	CORE_GET_ALL_RAW_MAT_REQUEST,
	CORE_GET_ALL_RAW_MAT_SUCCESS,
	CORE_GET_ALL_RAW_MAT_FAILURE,

	CORE_CREATE_PO_RECEIPT_SUCCESS,
	CORE_CREATE_PO_RECEIPT_FAILURE,

	CORE_CREATE_PACK_ITEMS_SUCCESS,
	CORE_CREATE_PACK_ITEMS_FAILURE,

	// Multi PD
	CORE_GET_MULTI_PD_RAW_MATT_REQUEST,
	CORE_GET_MULTI_PD_RAW_MATT_SUCCESS,
	CORE_GET_MULTI_PD_RAW_MATT_FAILURE,

	CORE_CREATE_MULTI_PD_RAW_MATT_REQUEST,
	CORE_CREATE_MULTI_PD_RAW_MATT_SUCCESS,
	CORE_CREATE_MULTI_PD_RAW_MATT_FAILURE,

	CORE_GET_ALL_MULTI_PD_RAW_MATT_REQUEST,
	CORE_GET_ALL_MULTI_PD_RAW_MATT_SUCCESS,
	CORE_GET_ALL_MULTI_PD_RAW_MATT_FAILURE,


	CORE_GET_MULTI_PD_RAW_MATT_BY_ID_REQUEST,
	CORE_GET_MULTI_PD_RAW_MATT_BY_ID_SUCCESS,
	CORE_GET_MULTI_PD_RAW_MATT_BY_ID_FAILURE,


	CORE_DELETE_MULTI_PD_REQUEST,
	CORE_DELETE_MULTI_PD_SUCCESS,
	CORE_DELETE_MULTI_PD_FAILURE,

	CORE_APPROVE_MULTI_PD_REQUEST,
	CORE_APPROVE_MULTI_PD_SUCCESS,
	CORE_APPROVE_MULTI_PD_FAILURE,

	CORE_SEND_MULTI_PD_REQUEST,
	CORE_SEND_MULTI_PD_SUCCESS,
	CORE_SEND_MULTI_PD_FAILURE,

	// RM Summary
	CORE_GET_ALL_RM_SUMMARY_RAW_MATT_REQUEST,
	CORE_GET_ALL_RM_SUMMARY_RAW_MATT_SUCCESS,
	CORE_GET_ALL_RM_SUMMARY_RAW_MATT_FAILURE,

	CORE_GET_RM_SUMMARY_RAW_MATT_REQUEST,
	CORE_GET_RM_SUMMARY_RAW_MATT_SUCCESS,
	CORE_GET_RM_SUMMARY_RAW_MATT_FAILURE,

	CORE_GET_RM_SUMMARY_RAW_MATT_BY_ID_REQUEST,
	CORE_GET_RM_SUMMARY_RAW_MATT_BY_ID_SUCCESS,
	CORE_GET_RM_SUMMARY_RAW_MATT_BY_ID_FAILURE,

	CORE_CREATE_RM_SUMMARY_RAW_MATT_REQUEST,
	CORE_CREATE_RM_SUMMARY_RAW_MATT_SUCCESS,
	CORE_CREATE_RM_SUMMARY_RAW_MATT_FAILURE,

	CORE_DELETE_RM_SUMMARY_REQUEST,
	CORE_DELETE_RM_SUMMARY_SUCCESS,
	CORE_DELETE_RM_SUMMARY_FAILURE,

	CORE_APPROVE_RM_SUMMARY_REQUEST,
	CORE_APPROVE_RM_SUMMARY_SUCCESS,
	CORE_APPROVE_RM_SUMMARY_FAILURE,

	CORE_SEND_RM_SUMMARY_REQUEST,
	CORE_SEND_RM_SUMMARY_SUCCESS,
	CORE_SEND_RM_SUMMARY_FAILURE,


} from '../types'

import {
	CORE_LOAD_MASTER_DATA_MATERIALS_REQUEST,
	CORE_LOAD_MASTER_DATA_MATERIALS_SUCCESS,
	CORE_LOAD_MASTER_DATA_MATERIALS_FAILURE,
} from '../masterDataTypes'


const initialStateCallAPI = {
	isLoading: false,

	hasError: false,
	errorMessage: '',
	errorCode: '',
	statusText: ''
}
	, initialStateArray = []


export default {
	errorList: (state = initialStateArray, action) => {
		switch (action.type) {
			case SET_ERROR:
				let newError = []
				if (action && Array.isArray(action.error)) {
					newError = action.error
				}
				return newError
			case CORE_AUTH_VERIFY_SUCCESS:
			case CORE_GET_ALL_TRANSFERS_SUCCESS:
			case CORE_GET_TRANSFER_BY_ID_SUCCESS:
			case CORE_GET_ALL_AX_RAW_MAT_SUCCESS:
			case CORE_GET_ALL_RAW_MATERIAL_SUCCESS:
			case CORE_GET_RAW_MATERIAL_BY_ID_SUCCESS:
			case CORE_CREATE_RAW_MATERIAL_SUCCESS:
			case CORE_UPDATE_RAW_MATERIAL_SUCCESS:
			case CORE_DELETE_RAW_MATERIAL_SUCCESS:
			case CORE_APPROVE_RAW_MATERIAL_SUCCESS:
			case CORE_SEND_RAW_MATERIAL_SUCCESS:
			case CORE_GET_ALL_RAW_MAT_SUCCESS:
			case CORE_CREATE_PO_RECEIPT_SUCCESS:
			case CORE_CREATE_PACK_ITEMS_SUCCESS:
			case CORE_GET_MULTI_PD_RAW_MATT_SUCCESS:
			case CORE_CREATE_MULTI_PD_RAW_MATT_SUCCESS:
				if (action && !Array.isArray(action.payload) && typeof action.payload === 'object') {
					const { errors, result } = action.payload
					const { url } = action
					let newError = []
					if (!result) {
						if (Array.isArray(errors)) {
							errors.map(e => {
								const { path, code, message } = e
								return newError.push({ code, message, isShow: true, path, url, isFromAction: true })
							})
						}
						else if (errors && errors.axError) {
							if (Array.isArray(errors.errors)) {
								errors.errors.map(e => {
									const { path, message } = e
									return newError.push({ code: "Please Contact AX Admin", message, isShow: true, isAxError: true, path, url, isFromAction: true })
								})
							} else newError.push({ code: "Please Contact AX Admin", message: errors.errors, isShow: true, isAxError: true, path: "", url, isFromAction: true })
						}
						else newError.push({ code: "unknow", message: "Some thing went wrong", isShow: true, path: "", url, isFromAction: true })
					}
					console.log("newErroo", newError)
					return newError
				}
				return state
			case CORE_AUTH_VERIFY_FAILURE:
			case CORE_GET_ALL_TRANSFERS_FAILURE:
			case CORE_GET_TRANSFER_BY_ID_FAILURE:
			case CORE_GET_ALL_AX_RAW_MAT_FAILURE:
			case CORE_GET_ALL_RAW_MATERIAL_FAILURE:
			case CORE_GET_RAW_MATERIAL_BY_ID_FAILURE:
			case CORE_CREATE_RAW_MATERIAL_FAILURE:
			case CORE_UPDATE_RAW_MATERIAL_FAILURE:
			case CORE_DELETE_RAW_MATERIAL_FAILURE:
			case CORE_APPROVE_RAW_MATERIAL_FAILURE:
			case CORE_SEND_RAW_MATERIAL_FAILURE:
			case CORE_GET_ALL_RAW_MAT_FAILURE:
			case CORE_CREATE_PO_RECEIPT_FAILURE:
			case CORE_CREATE_PACK_ITEMS_FAILURE:
			case CORE_GET_MULTI_PD_RAW_MATT_FAILURE:
			case CORE_CREATE_MULTI_PD_RAW_MATT_FAILURE:
				if (action && !Array.isArray(action.payload) && typeof action.payload === 'object') {
					console.log("action", action)
					const { code, message, statusText, statusCode } = action.payload
					const { url } = action
					let newError = []

					newError.push({
						code: code ? code : "404",
						message,
						isShow: false,
						statusText,
						statusCode,
						url
					})

					return newError
				}
				return state
			default:
				return state
		}
	},
	isLoading: (state = false, action) => {
		switch (action.type) {
			case CORE_GET_ALL_TRANSFERS_REQUEST:
			case CORE_GET_TRANSFER_BY_ID_REQUEST:
			case CORE_CREATE_TRANSFER_REQUEST:
			case CORE_TRANSFER_ITEM_REQUEST:
			case CORE_GET_SETTINGS_REQUEST:
			case CORE_GET_RM_TAG_REQUEST:
			case CORE_GET_PD_TAG_REQUEST:
			case CORE_GET_DELIVERY_TAG_REQUEST:
			case CORE_GET_PO_RECEIPT_REQUEST:
			case CORE_GET_LIST_SO_REQUEST:
			case CORE_GET_SO_INFO_REQUEST:
			case CORE_GET_SO_PICK_REQUEST:
			case CORE_UPSERT_SETTINGS_REQUEST:
			case CORE_GET_ALL_AX_RAW_MAT_REQUEST:
			case CORE_GET_ALL_RAW_MATERIAL_REQUEST:
			case CORE_GET_RAW_MATERIAL_BY_ID_REQUEST:
			case CORE_CREATE_RAW_MATERIAL_REQUEST:
			case CORE_UPDATE_RAW_MATERIAL_REQUEST:
			case CORE_DELETE_RAW_MATERIAL_REQUEST:
			case CORE_APPROVE_RAW_MATERIAL_REQUEST:
			case CORE_SEND_RAW_MATERIAL_REQUEST:
			case CORE_GET_ALL_RAW_MAT_REQUEST:
			case CORE_LOAD_MASTER_DATA_MATERIALS_REQUEST:
			case CORE_GET_MULTI_PD_RAW_MATT_REQUEST:
			case CORE_CREATE_MULTI_PD_RAW_MATT_REQUEST:
			case CORE_GET_ALL_MULTI_PD_RAW_MATT_REQUEST:
			case CORE_GET_MULTI_PD_RAW_MATT_BY_ID_REQUEST:
			case CORE_DELETE_MULTI_PD_REQUEST:
			case CORE_APPROVE_MULTI_PD_REQUEST:
			case CORE_SEND_MULTI_PD_REQUEST:
			case CORE_GET_ALL_RM_SUMMARY_RAW_MATT_REQUEST:
			case CORE_GET_RM_SUMMARY_RAW_MATT_REQUEST:
			case CORE_GET_RM_SUMMARY_RAW_MATT_BY_ID_REQUEST:
			case CORE_CREATE_RM_SUMMARY_RAW_MATT_REQUEST:
			case CORE_DELETE_RM_SUMMARY_REQUEST:
			case CORE_APPROVE_RM_SUMMARY_REQUEST:
			case CORE_SEND_RM_SUMMARY_REQUEST:
				return true
			case CORE_GET_ALL_TRANSFERS_SUCCESS:
			case CORE_GET_TRANSFER_BY_ID_SUCCESS:
			case CORE_CREATE_TRANSFER_SUCCESS:
			case CORE_TRANSFER_ITEM_SUCCESS:
			case CORE_GET_SETTINGS_SUCCESS:
			case CORE_GET_RM_TAG_SUCCESS:
			case CORE_GET_PD_TAG_SUCCESS:
			case CORE_GET_DELIVERY_TAG_SUCCESS:
			case CORE_GET_PO_RECEIPT_SUCCESS:
			case CORE_GET_LIST_SO_SUCCESS:
			case CORE_GET_SO_INFO_SUCCESS:
			case CORE_GET_SO_PICK_SUCCESS:
			case CORE_UPSERT_SETTINGS_SUCCESS:
			case CORE_GET_ALL_AX_RAW_MAT_SUCCESS:
			case CORE_GET_ALL_RAW_MATERIAL_SUCCESS:
			case CORE_GET_RAW_MATERIAL_BY_ID_SUCCESS:
			case CORE_CREATE_RAW_MATERIAL_SUCCESS:
			case CORE_UPDATE_RAW_MATERIAL_SUCCESS:
			case CORE_DELETE_RAW_MATERIAL_SUCCESS:
			case CORE_APPROVE_RAW_MATERIAL_SUCCESS:
			case CORE_SEND_RAW_MATERIAL_SUCCESS:
			case CORE_GET_ALL_RAW_MAT_SUCCESS:
			case CORE_LOAD_MASTER_DATA_MATERIALS_SUCCESS:
			case CORE_GET_MULTI_PD_RAW_MATT_SUCCESS:
			case CORE_CREATE_MULTI_PD_RAW_MATT_SUCCESS:
			case CORE_GET_ALL_MULTI_PD_RAW_MATT_SUCCESS:
			case CORE_GET_MULTI_PD_RAW_MATT_BY_ID_SUCCESS:
			case CORE_DELETE_MULTI_PD_SUCCESS:
			case CORE_APPROVE_MULTI_PD_SUCCESS:
			case CORE_SEND_MULTI_PD_SUCCESS:
			case CORE_GET_ALL_RM_SUMMARY_RAW_MATT_SUCCESS:
			case CORE_GET_RM_SUMMARY_RAW_MATT_SUCCESS:
			case CORE_GET_RM_SUMMARY_RAW_MATT_BY_ID_SUCCESS:
			case CORE_CREATE_RM_SUMMARY_RAW_MATT_SUCCESS:
			case CORE_DELETE_RM_SUMMARY_SUCCESS:
			case CORE_APPROVE_RM_SUMMARY_SUCCESS:
			case CORE_SEND_RM_SUMMARY_SUCCESS:
				return false
			case CORE_GET_ALL_TRANSFERS_FAILURE:
			case CORE_GET_TRANSFER_BY_ID_FAILURE:
			case CORE_CREATE_TRANSFER_FAILURE:
			case CORE_TRANSFER_ITEM_FAILURE:
			case CORE_GET_SETTINGS_FAILURE:
			case CORE_GET_RM_TAG_FAILURE:
			case CORE_GET_PD_TAG_FAILURE:
			case CORE_GET_DELIVERY_TAG_FAILURE:
			case CORE_GET_PO_RECEIPT_FAILURE:
			case CORE_GET_LIST_SO_FAILURE:
			case CORE_GET_SO_INFO_FAILURE:
			case CORE_GET_SO_PICK_FAILURE:
			case CORE_UPSERT_SETTINGS_FAILURE:
			case CORE_GET_ALL_AX_RAW_MAT_FAILURE:
			case CORE_GET_ALL_RAW_MATERIAL_FAILURE:
			case CORE_GET_RAW_MATERIAL_BY_ID_FAILURE:
			case CORE_CREATE_RAW_MATERIAL_FAILURE:
			case CORE_UPDATE_RAW_MATERIAL_FAILURE:
			case CORE_DELETE_RAW_MATERIAL_FAILURE:
			case CORE_APPROVE_RAW_MATERIAL_FAILURE:
			case CORE_SEND_RAW_MATERIAL_FAILURE:
			case CORE_GET_ALL_RAW_MAT_FAILURE:
			case CORE_LOAD_MASTER_DATA_MATERIALS_FAILURE:
			case CORE_GET_MULTI_PD_RAW_MATT_FAILURE:
			case CORE_CREATE_MULTI_PD_RAW_MATT_FAILURE:
			case CORE_GET_ALL_MULTI_PD_RAW_MATT_FAILURE:
			case CORE_GET_MULTI_PD_RAW_MATT_BY_ID_FAILURE:
			case CORE_DELETE_MULTI_PD_FAILURE:
			case CORE_APPROVE_MULTI_PD_FAILURE:
			case CORE_SEND_MULTI_PD_FAILURE:
			case CORE_GET_ALL_RM_SUMMARY_RAW_MATT_FAILURE:
			case CORE_GET_RM_SUMMARY_RAW_MATT_FAILURE:
			case CORE_GET_RM_SUMMARY_RAW_MATT_BY_ID_FAILURE:
			case CORE_CREATE_RM_SUMMARY_RAW_MATT_FAILURE:
			case CORE_DELETE_RM_SUMMARY_FAILURE:
			case CORE_APPROVE_RM_SUMMARY_FAILURE:
			case CORE_SEND_RM_SUMMARY_FAILURE:
				return false
			default:
				return state
		}

	},
	reducerCallAPI: (state = initialStateCallAPI, action) => {
		switch (action.type) {

			default:
				return state
		}
	},

}


// WEBPACK FOOTER //
// ./src/app/redux/reducers/reducerCallAPI.js